import  i18next  from "i18next";
import { initReactI18next } from "react-i18next";
import auth_en from "./translations/en/auth.json";
import auth_ja from "./translations/ja/auth.json";

const resources = {
    en : {
        auth: auth_en
    },
    ja : {
        auth: auth_ja
    }
};

i18next
.use(initReactI18next)
.init({
    resources,
    lng: "ja",
    keySeparator: false,
    interpolation: {
        escapeValue: false
    }
});

export default i18next;